import { faArrowTurnDownRight } from '@fortawesome/pro-regular-svg-icons';
import { type TripUrlParams } from './trip';
import { type Location, SearchMode } from './types';

export interface City {
    id: number;
    title: string;
    isDomestic: boolean;
    isForeign: boolean;
    terminals: Terminal[] | null;
    englishTitle?: string;
    code?: string | null;
}

export interface Terminal {
    id: number;
    title: string;
    persianTitle: string;
    englishTitle: string | null;
    code?: string | null;
}

export function getLocationCode(location: City | Terminal) {
    if (location.code) {
        return location.code;
    } else {
        return `${location.id}`;
    }
}

export function provincesToLocations(
    provinces: Province[],
    searchMode?: SearchMode
): BusLocation[] {
    return provinces
        .flatMap(p => p.cities)
        .filter(
            c =>
                !searchMode ||
                (searchMode === SearchMode.Domestic
                    ? c.isDomestic
                    : c.isForeign)
        )
        .map(city => ({
            code: getLocationCode(city),
            title: city.title,
            terminalId: city.id,
            subLocations: city.terminals?.map(terminal => ({
                code: getLocationCode(terminal),
                terminalId: terminal.id,
                title: `${terminal.title.trim()} - ${terminal.persianTitle.trim()}`,
                icon: faArrowTurnDownRight,
            })),
        }));
}

export interface BusLocation extends Location<BusLocation> {
    terminalId: number;
}

export interface BusUrlParams extends TripUrlParams {
    originTerminalId: number;
    destinationTerminalId: number;
}

export interface Province {
    provinceName: string;
    cities: City[];
}
